import { db } from '../main.js'

// Fetch the combined geoJson from Firestore

export {
  combinedGeoJson
}

async function combinedGeoJson () {
  const geoJson = await getGeoJson()
  return geoJson
}

function getGeoJson () {
  return new Promise(function (resolve, reject) {
    db.collection('geojson').doc('combined').get()
      .then((doc) => {
        if (doc.exists) {
          resolve(doc.data())
        } else {
        // doc.data() will be undefined in this case
          reject(Error('No such document!'))
        }
      })
      .catch(function (error) {
        console.log('Error getting document:', error)
      })
  })
}
